<script setup lang="ts">
import { type AuctionListingItemEntity, AuctionState } from '~/apiClient';

// PROPS
interface Props {
    auction: AuctionListingItemEntity;
}

const { auction } = defineProps<Props>();

// COMPOSABLES
const { tt, tte } = useTypedI18n();

// DATA
const hasCountdown = computed(() => [AuctionState.Pending, AuctionState.Running].includes(auction.state));
</script>

<template>
    <AdpCountdown v-if="hasCountdown" :auction="auction" />
    <p v-else-if="tte(`sdp.Auction.state.${auction.state}`)" class="tracking-wide uppercase">
        {{ tt(`sdp.Auction.state.${auction.state}` as TranslationKey) }}
    </p>
</template>
